import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useAnalytics } from '../hooks/useAnalytics';

const AnalyticsDashboard = () => {
  const { user } = useAuth();
  const { trackUserAction } = useAnalytics();
  const [analyticsData, setAnalyticsData] = useState({
    totalVisits: 0,
    returnVisits: 0,
    lastVisit: null,
    calculationsCompleted: 0
  });

  useEffect(() => {
    if (user) {
      // Load user-specific analytics data from localStorage
      const visitCount = parseInt(localStorage.getItem(`visitCount_${user.id}`) || '0');
      const lastVisit = localStorage.getItem(`lastVisit_${user.id}`);
      const calculationsCount = parseInt(localStorage.getItem(`calculations_${user.id}`) || '0');

      setAnalyticsData({
        totalVisits: visitCount,
        returnVisits: Math.max(0, visitCount - 1), // First visit doesn't count as return
        lastVisit: lastVisit ? new Date(lastVisit).toLocaleDateString() : 'Never',
        calculationsCompleted: calculationsCount
      });

      trackUserAction('analytics_dashboard_viewed');
    }
  }, [user, trackUserAction]);

  if (!user) {
    return <div>Please log in to view analytics.</div>;
  }

  return (
    <div className="analytics-dashboard">
      <h2>Your Analytics</h2>
      <div className="analytics-grid">
        <div className="analytics-card">
          <h3>Total Visits</h3>
          <p className="analytics-number">{analyticsData.totalVisits}</p>
        </div>
        <div className="analytics-card">
          <h3>Return Visits</h3>
          <p className="analytics-number">{analyticsData.returnVisits}</p>
        </div>
        <div className="analytics-card">
          <h3>Last Visit</h3>
          <p className="analytics-date">{analyticsData.lastVisit}</p>
        </div>
        <div className="analytics-card">
          <h3>Calculations Completed</h3>
          <p className="analytics-number">{analyticsData.calculationsCompleted}</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard; 